module.exports = __webpack_public_path__ + "static/media/carPhoto4.2ffe9c57.jpg";